import React from "react";
import T from "prop-types";
import { Modal, Close, Header, Body } from "MODULES/shared/components/Modal";
import {
  MANAGED_REPAIR_IN_PROGRESS,
  RESERVE_FOR_SALE,
  SALES_ORDER_CREATED,
  STATUS
} from "MODULES/inventories/constants";
import Warning from "MODULES/shared/components/Warning/Warning";
import { RMA_REQUEST_TYPE } from "MODULES/RepairOrders/constants";
import { RMA } from "MODULES/Receiving/constants";
import Form from "./Form";

function RmaRequestModal({ editing, close, inventory }) {
  const managedRepair = inventory.get(MANAGED_REPAIR_IN_PROGRESS);
  return (
    <Modal open={editing} close={close} dialogClass="modal-lg">
      <Header>
        <Close close={close} />
        <h4 className="modal-title">
          {managedRepair ? "" : "Vendor "}RMA Request
        </h4>
      </Header>
      <Body>
        {[SALES_ORDER_CREATED, RESERVE_FOR_SALE].includes(
          inventory.get(STATUS)
        ) ? (
          <Warning>
            Please cancel the existing SO and return to stock before requesting
            a vendor RMA.{" "}
          </Warning>
        ) : (
          <Form
            close={close}
            managedRepair={managedRepair}
            initialValues={{ [RMA_REQUEST_TYPE]: RMA }}
            enableReinitialize
          />
        )}
      </Body>
    </Modal>
  );
}

RmaRequestModal.propTypes = {
  close: T.func.isRequired,
  editing: T.bool.isRequired,
  inventory: T.instanceOf(Map)
};

export default RmaRequestModal;



// WEBPACK FOOTER //
// ./app/modules/inventories/components/Detail/Header/DropdownActions/CreateVendorRma/RmaRequestModal.jsx